import { render } from "./RequestRegisterBrandEdit.vue?vue&type=template&id=481d3c5e&scoped=true"
import script from "./RequestRegisterBrandEdit.vue?vue&type=script&lang=js"
export * from "./RequestRegisterBrandEdit.vue?vue&type=script&lang=js"

import "./RequestRegisterBrandEdit.vue?vue&type=style&index=0&id=481d3c5e&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481d3c5e"]])

export default __exports__